"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocale = void 0;
var _reactIntl = require("react-intl");
var _logService = require("../tools/service/log/logService");
var _KnownLocales = _interopRequireDefault(require("../type-tools/KnownLocales"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var AVAILABLE_LOCALES = Object.values(_KnownLocales["default"]);
var getLocale = exports.getLocale = function getLocale(intl) {
  var locale = _KnownLocales["default"].FALLBACK;
  try {
    var _ref = intl || (0, _reactIntl.useIntl)(),
      selectedLocale = _ref.locale;
    locale = selectedLocale;
  } catch (e) {
    (0, _logService.logSpecificErrorMessage)('getLocale', e);
  }
  if (locale && AVAILABLE_LOCALES.includes(locale)) return locale;
  return _KnownLocales["default"].FALLBACK;
};